<div class="notice-wrapper" *ngIf="active" [ngClass]="{isMobile}">
  <h4>Hi investor!</h4>
  <app-shared-icon
    name="close"
    class="close-icon"
    [size]="12"
    (click)="close()"
  ></app-shared-icon>
  <p>
    Starting at approximately 9:30AM ET/8:30AM CT this morning (May 26th), the
    Marketplace will be unavailable for approximately 30 minutes due to
    maintenance. We apologize for the short notice and any inconvenience.
  </p>
</div>
